import React, { useContext, useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Analysis from "./Analysis from fields";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";
import Box from "@mui/material/Box";
import "./styles/Analysis.css";

function AnalysisContainerAsFooter(props) {
  const [analysisToDisplay, setAnalysisToDisplay] = useState([]);
  const refreshFlag = useRef(false);
  const creds = useContext(CredsContext).creds;
  //props.waitHandler(true);
  let grid;

  refreshFlag.current = !refreshFlag.current;

  //useEffect(() => {
  if (refreshFlag.current) {
    const analysisObject = new Analysis(props.projectid, creds);
    analysisObject.getTaskAnalysis().then((results) => {
      const taskLineArray = [];
      for (var i = 0; i < results.length; i++) {
        if (results[i].messageArray) {
          if (results[i].messageArray.length > 0) {
            taskLineArray.push(results[i]);
          }
        }
      }
      setAnalysisToDisplay(taskLineArray);
    });
  } //, []); // change this to trigger on refresh flag

  const formatMessage = (field, data, column) => {
    const messageArray = data.messageArray;
    const newMessageArray = [];
    for (let i = 0; i < messageArray.length; i++) {
      const messageSplit = messageArray[i].split("|");
      let color = "black";
      if (messageSplit[1].substring(0, 1) == "R") {
        color = "crimson";
      } else if (messageSplit[1].substring(0, 1) == "Y") {
        color = "rgb(197, 168, 5)";
      } else if (messageSplit[1].substring(0, 1) == "G") {
        color = "green";
      }
      newMessageArray.push(
        "<span>" +
          messageSplit[0] +
          '</span><span style="font-weight:bold; color:' +
          color +
          '">' +
          messageSplit[1].substring(1) +
          "</span><span>" +
          messageSplit[2] +
          "</span>",
      );
    }
    const addBreaks = newMessageArray.join("<br>");
    return addBreaks;
  };

  const dataBound = (args) => {
    //grid.getColumnHeaderByField("Task").style.background = "#f45ddeab";
    grid.getColumnHeaderByField("Task").style.fontsize = "large";
    grid.getColumnHeaderByField("messageArray").style.color = "#0d0b0b";
    grid.getColumnHeaderByField("messageArray").style.size = "x-large";
  };

  const handleRowSelection = (event) => {
    props.handleAnalysisRowClick(event.data.Task___Internal_id);
  };

  useEffect(() => {
    if (grid) {
      grid.getColumnByField("messageArray").disableHtmlEncode = false;
      grid.getColumnByField("Task").disableHtmlEncode = false;

      const headerCells = grid
        .getHeaderContent()
        .querySelectorAll(".e-headercell");
      headerCells.forEach((headerCell) => {
        headerCell.style.height = "20px";
        headerCell.style.background = "#154360";
      });
    }
  }, [grid]);

  const alertsHeader = () => {
    return null;
  };
  return (
    <Box className={props.className}>
      <GridComponent
        dataSource={analysisToDisplay}
        ref={(g) => (grid = g)}
        rowSelected={handleRowSelection}
      >
        <ColumnsDirective>
          <ColumnDirective
            field="Task"
            headerText="Task Alerts"
            width="280"
            textAlign="Left"
            customAttributes={{ class: "analysisTaskName" }}
          />
          <ColumnDirective
            field="messageArray"
            headerText=""
            textAlign="Left"
            headerTemplate={alertsHeader}
            valueAccessor={formatMessage}
            customAttributes={{ class: "messagetext" }}
          />
        </ColumnsDirective>
      </GridComponent>
    </Box>
  );
}

export default AnalysisContainerAsFooter;

AnalysisContainerAsFooter.propTypes = {
  projectid: PropTypes.string,
  projectname: PropTypes.string,
  waitHandler: PropTypes.func,
  handleAnalysisRowClick: PropTypes.func,
  className: PropTypes.string,
};
